'use client';

import { useEffect } from 'react';
import { toastBus } from '@/components/ToastContext';

export function GlobalErrorHandlers() {
  useEffect(() => {
    const onUnhandledRejection = (e: PromiseRejectionEvent) => {
      const reason = e.reason;
      if (reason instanceof Error && reason.name === 'AbortError') return;
      const msg = reason instanceof Error ? reason.message : String(reason ?? 'Unknown rejection');
      toastBus.error('Unhandled error', { message: msg, dedupeKey: `error|${msg}` });
    };

    const onError = (e: ErrorEvent) => {
      // Skip resource-load failures (img/script/link src errors) — those have no e.error
      if (!e.error && !e.message) return;
      const msg = e.message || String(e.error) || 'Script error';
      toastBus.error('Script error', { message: msg, dedupeKey: `error|${msg}` });
    };

    window.addEventListener('unhandledrejection', onUnhandledRejection);
    window.addEventListener('error', onError as EventListener);
    return () => {
      window.removeEventListener('unhandledrejection', onUnhandledRejection);
      window.removeEventListener('error', onError as EventListener);
    };
  }, []);

  return null;
}
